import {
  component_styles_default,
  r
} from "./chunk.3PRAXUFA.js";

// node_modules/@shoelace-style/shoelace/dist/chunks/chunk.ROMUUZA2.js
var breadcrumb_styles_default = r` ${component_styles_default} .breadcrumb { display: flex; align-items: center; flex-wrap: wrap; } `;

export {
  breadcrumb_styles_default
};
